module.exports = __webpack_public_path__ + "static/img/GR1077-FCM-SDW375-BB-2.9b696d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/GR1077-FCM-SDW375-BB-2.jpg
// module id = jWnD
// module chunks = 0